const initialState = {
  items: [],
  searchValue: '',
  categoryValue: 'all',
  bookToUpdate: null,
};

export default initialState;
